import type { ClientConfig } from '@/types/api';

/** What the page can start: the app with a config, or the failure without one. */
interface StartTargets {
    startApp: (config: ClientConfig) => void;
    onFailed: () => void;
}

/** Without the cloud's config no transport exists, so the app must not start. */
export function startPage(config: ClientConfig | null, targets: StartTargets): void {
    if (config === null) {
        targets.onFailed();
        return;
    }
    targets.startApp(config);
}
